const TENANT_ID = 'd8eb9d04-d7a6-4f60-8228-275da7b25fb8';

// Kairos Web UI (prod) — the only live SPA app reg. The Phase 1 spike
// "Kairos Web UI (next)" reg + the kairos-web.* hostname were both
// removed in Phase 4 cleanup (tf PR 4625 dropped entra_dev.tf).
const CLIENT_ID = 'ab91f0d6-bb63-4d53-a825-5f553f77e631';
const API_AUDIENCE = 'api://d8eb9d04-d7a6-4f60-8228-275da7b25fb8/trailhead-kairos-prod-api';
const API_SCOPE = `${API_AUDIENCE}/access_as_user`;

interface RuntimeConfig {
  API_BASE: string;
  CLIENT_ID: string;
  TENANT_ID: string;
  API_SCOPE: string;
}

function resolveConfig(): RuntimeConfig {
  const hostname = window.location.hostname;

  // Local web dev talks cross-origin to the deployed API so localhost
  // exercises the same browser CORS/SSE/auth path as the deployed SPA.
  // Terraform temporarily allowlists localhost origins + redirect URIs when
  // local_web_dev_enabled=true.
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Optional override: setting VITE_API_BASE in .env or on the npm-run-dev
    // command line points local SPA → local API (e.g. VITE_API_BASE="" routes
    // through the Vite proxy to localhost:5000). Used during Phase-2 local
    // testing of features that haven't deployed to the prod API yet. Empty
    // string is intentional — relative fetches go through the same-origin
    // proxy defined in vite.config.ts.
    const localOverride = import.meta.env.VITE_API_BASE;
    return {
      API_BASE: localOverride !== undefined
        ? localOverride
        : 'https://kairos-api.trailheadtechnology.com',
      CLIENT_ID,
      TENANT_ID,
      API_SCOPE,
    };
  }

  // Prod canonical hostname.
  if (hostname === 'kairos.trailheadtechnology.com') {
    return {
      API_BASE: 'https://kairos-api.trailheadtechnology.com',
      CLIENT_ID,
      TENANT_ID,
      API_SCOPE,
    };
  }

  // Fallback for SWA preview URLs (<random>.<region>.azurestaticapps.net)
  // — same prod client + API; only the SPA host differs.
  return {
    API_BASE: 'https://kairos-api.trailheadtechnology.com',
    CLIENT_ID,
    TENANT_ID,
    API_SCOPE,
  };
}

export const CONFIG: RuntimeConfig = resolveConfig();
